import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { all_routes } from "../router/all_routes";
import PerformanceSelfReview from "./performanceSelf-Review";
import PerformanceReview from "./performanceReview";
import {
  getEmployeeById,
  getEmployeeByUserId,
} from "../../core/data/redux/employee/employeeAction";
import { AppDispatch } from "../../core/data/redux/store";
import { fetchappliedappraisalById } from "../../core/data/redux/performance/appliedappraisal/appliedappraisalAction";
import { formatDate } from "../../core/utils/configFormatters";
import { useAppConfig } from "../../customhooks/useAppConfig";

const StarRating = ({
  rating,
  onRate,
}: {
  rating: any;
  onRate?: (rating: any) => void;
}) => {
  const handleClick = (star: number, isHalf: boolean) => {
    const newRating = isHalf ? star - 0.5 : star;
   
  };

  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <div
          key={star}
          style={{ position: "relative", fontSize: "24px", cursor: "pointer" }}
        >
          <span
            style={{
              position: "absolute",
              width: "50%",
              overflow: "hidden",
              color: rating >= star - 0.5 ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, true)}
          >
            ★
          </span>

          <span
            style={{
              color: rating >= star ? "gold" : "gray",
            }}
            onClick={() => handleClick(star, false)}
          >
            ★
          </span>
        </div>
      ))}
    </div>
  );
};

const Performance = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [activeTab, setActiveTab] = useState("goalTracking");
  const [reviewStarted, setReviewStarted] = useState(false);
  const [employeedata, setEmployeedata] = useState<any>([]);
  console.log(employeedata,'employeedata')
  const [employeeExprience, setemployeeExprience] = useState<any>([]);
  const [filteredRoleIndicators, setFilteredRoleIndicators] = useState<any[]>(
    []
  );
  const { user } = useSelector((state: any) => state.auth);
  const { roleindicator } = useSelector(
    (state: any) => state.performance.roleindicator
  );

  const { appliedappraisal } = useSelector(
    (state: any) => state.performance.appliedappraisal
  );
  const targetUserId = user.UserId;
  // const targetUserId = "66";

  useEffect(() => {
    if (employeedata?.length > 0 && roleindicator?.length > 0) {
      const uniqueDesignationIds = Array.from(
        new Set(employeedata.map((emp: any) => emp.DesignationId))
      );
      const matchedRoleIndicators = roleindicator.filter((role: any) =>
        uniqueDesignationIds.includes(role.DesignationId)
      );

      setFilteredRoleIndicators(matchedRoleIndicators);
    }
  }, [employeedata, roleindicator]);

  const [appliedappraisaldetails, setappliedappraisaldetails] = useState<any>(
    []
  );
  console.log(appliedappraisaldetails , 'applieddetails');
  const [statusMap, setStatusMap] = useState<{ [key: number]: string }>({});

  const handleStatusChange = (employeeID: any, newStatus: any) => {
    setStatusMap((prev) => ({ ...prev, [employeeID]: newStatus }));
  };

  const location = useLocation();
        const { permissions, label } = location.state || {};
        const canView = permissions?.includes("View") || permissions?.includes("AllowAll");
        const canEdit = permissions?.includes("Edit") || permissions?.includes("AllowAll");
        const canDelete = permissions?.includes("Delete") || permissions?.includes("AllowAll");

  useEffect(() => {
    dispatch(getEmployeeByUserId({ userId: targetUserId })).then((res) => {
      dispatch(
        getEmployeeById({ employeeId: res?.payload.data?.employeeId })
      ).then((res) => {
        setEmployeedata(res.payload.data.employee);
        setemployeeExprience(res.payload.data.experience);
      });
    });
  }, [dispatch]);

  useEffect(() => {
    setTimeout(() => {
      let Id = employeedata[0]?.EmployeeID;
      dispatch(fetchappliedappraisalById(Id)).then((res) => {
        setappliedappraisaldetails(res.payload.data);
      });
    }, 1000);
  }, [employeedata]);

  
  const routes = all_routes;
  const config = useAppConfig() ?? {};

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Performance</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Performance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add New Performance
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-end">
              <button
                className={`btn btn-${
                  activeTab === "goalTracking" ? "primary" : "light"
                } mx-1`}
                onClick={() => setActiveTab("goalTracking")}
              >
                Self
              </button>
              <button
                className={`btn btn-${
                  activeTab === "goalType" ? "primary" : "light"
                } mx-1`}
                onClick={() => setActiveTab("goalType")}
              >
                Team
              </button>
            </div>
            <div className="p-3 w-100 h-100">
              {activeTab === "goalTracking" ? (
                <div className="p-3">
                  {reviewStarted ? (
                    <PerformanceSelfReview
                      onClose={() => setReviewStarted(false)}
                    />
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-12 col-sm-12">
                          <div className="table-responsive">
                            <form>
                              <table className="table table-bordered table-nowrap mb-0">
                                <tbody>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="name"
                                      >
                                        Name
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={employeedata?.[0]?.Name}
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="department"
                                      >
                                        Department
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="department"
                                        value={
                                          employeedata?.[0]?.department_name
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="designation"
                                      >
                                        Designation
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="designation"
                                        value={
                                          employeedata?.[0]?.designation_name
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="qualification"
                                      >
                                        Qualification
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="qualification"
                                        value={
                                          employeedata?.[0]?.HighestEducation
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="empID"
                                      >
                                        Emp ID
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="empID"
                                        value={
                                          employeedata?.[0]?.EmployeeNumber
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="dateOfJoin"
                                      >
                                        Date of Join
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="dateOfJoin"
                                        value={ employeedata?.[0]?.DateOfJoining ? formatDate(employeedata[0].DateOfJoining, config) : "" }                                          disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="dateOfConfirmation"
                                      >
                                        Date of Confirmation
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="dateOfConfirmation"
                                        value={
                                          employeedata?.[0]?.DateOfConfirmation
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="previousExperience"
                                      >
                                        Previous years of Exp
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="previousExperience"
                                        value={
                                          employeedata?.[0]?.total_experience
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="roName"
                                      >
                                        RO's Name
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="roName"
                                        value={
                                          employeedata?.[0]?.supervisor_name ||
                                          "Ram"
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <label
                                        className="form-label"
                                        htmlFor="roDesignation"
                                      >
                                        RO Designations
                                      </label>
                                    </td>
                                    <td colSpan={2}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="roDesignation"
                                        value={
                                          employeedata?.[0]?.RODesignation ||
                                          "IT"
                                        }
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="text-center mt-3">
                        <button
                          className="btn btn-primary"
                          onClick={() => setReviewStarted(true)}
                        >
                          Start Review
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <PerformanceReview />
              )}
            </div>
          </div>
        </div>

        {!reviewStarted ? (
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Applied Review Status</h4>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Self-Rating</th>
                      <th scope="col">Status</th>
                      <th scope="col">Date</th>
                      <th scope="col">Frequency</th>
                    </tr>
                  </thead>
                  <tbody>
                    {appliedappraisaldetails?.length > 0 ? (
                      appliedappraisaldetails.map((emp: any, index: any) => (
                        <tr key={emp.Id}>
                          <td>{`${emp.employee_name}`}</td>
                          <td><StarRating
                              rating={emp.selfRating}
                            /></td>
                          <td>{emp.status}</td>
                          <td>{emp.date.split("T")[0]}</td>
                          <td>{emp.frequency}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center">
                          No employees found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}

        {/* <div className="card">
      <div className="card-body">
        <h4 className="card-title">Applied Review Status</h4>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead className="thead-dark">
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Name</th>
                <th scope="col">Expected Rating</th>
                <th scope="col">Status</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {employees.length > 0 ? (
                employees.map((emp, index) => (
                  <tr key={emp.EmployeeID}>
                    <td>{index + 1}</td>
                    <td>{`${emp.FirstName} ${emp.LastName}`}</td>
                    <td>{"N/A"}</td>
                    <td>{"Pending"}</td> 
                    <td>{emp.CreatedAt}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="text-center">No employees found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div> */}

        {/* Footer */}
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
    </>
  );
};

export default Performance;
